module.exports = __webpack_public_path__ + "img/col_bg.dc7c3163.png";